import './styles/style.scss';

console.log('App loaded');
